export default {
    namespaced: true,

    state: {
        unreadMessagesCount: 0,
    },

    getters: {
        getUnread(state) {
            return state.unreadMessagesCount
        },
    },

    mutations: {
        setUnread(state, unreadMessagesCount) {
            state.unreadMessagesCount = unreadMessagesCount
        },
        clearUnread(state) {
            state.unreadMessagesCount = 0
        },
    },

    actions: {
        setUnread(Store, unreadMessagesCount) {
            Store.commit('setUnread', unreadMessagesCount)
        },

        clear(Store) {
            Store.commit('clearUnread')
        },
    },
}
